import React from "react";
import s from "./style.module.scss";
import Coins from "shared/ui/Bonuses/icons/Coins";
import Scan from "shared/icons/Scan";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import { redirectToScanApp } from "shared/lib/redirectToScanApp";
import { Link } from "react-router-dom";
import { ROUTES_PATH } from "shared/constants/routesPath";

const AccountBalance: React.FC = () => {
  const { user_info } = useAppSelector(userSelect);

  return (
    <div className={s.balance}>
      <div>
        <div className={s.count}>
          <Coins />
          {user_info?.balance !== undefined ? user_info?.balance : "..."}
        </div>

        <Link to={ROUTES_PATH.HISTORY} className={s.label}>
          История начислений
        </Link>
      </div>

      <button
        onClick={() => redirectToScanApp(user_info?.msisdn!)}
        className={s.scan}
      >
        <Scan />
        Сканировать чек
      </button>
    </div>
  );
};

export default AccountBalance;
